module.exports = __webpack_public_path__ + "static/media/Datas_Cybersecurity_com_Solucoes_Open_Source.eef1300a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Datas_Cybersecurity_com_Solucoes_Open_Source.png
// module id = 54
// module chunks = 0